<a [routerLink]="post.link" class="tiny-post-container" *ngIf="post" data-aos="fade-up"  data-aos-once="true" data-aos-duration="1000">
  <media-attachment
    *ngIf="post.featured_media"
    [sizeXL]="sizeXL"
    [sizeLG]="sizeLG"
    [sizeMD]="sizeMD"
    [sizeSM]="sizeSM"
    [sizeXS]="sizeXS"
    [attachment]="post.featured_media_object"
  ></media-attachment>
  <div class="title" [innerHTML]="title != '' && title ? title : post.title.rendered"></div>
</a>
<div class="tiny-post-container__placeholder" *ngIf="!post">

</div>
